import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/noto-sans-arabic/noto-sans-arabic-400.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/noto-sans-arabic/noto-sans-arabic-500.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/noto-sans-arabic/noto-sans-arabic-600.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/noto-sans-arabic/noto-sans-arabic-700.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22variable%22:%22--font-noto-sans-arabic%22,%22display%22:%22swap%22,%22preload%22:true,%22fallback%22:[%22Tahoma%22,%22sans-serif%22],%22adjustFontFallback%22:%22Arial%22}],%22variableName%22:%22notoSansArabic%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'notoSansArabic', 'notoSansArabic Fallback', Tahoma, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
